import { useState, type FormEvent } from "react";
import { api, ApiError } from "@/lib/apiClient";
import { PasswordInput } from "@/components/PasswordInput";

export function LoginPage({ onLoggedIn }: { onLoggedIn: () => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setError(null);
    try {
      await api.post("/auth/login", { email: email.trim().toLowerCase(), password });
      onLoggedIn();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "ログインに失敗しました。");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        background: "var(--color-bg)",
      }}
    >
      <form onSubmit={submit} className="card card-padded" style={{ width: "100%", maxWidth: 380 }}>
        <h1 className="page-title" style={{ textAlign: "center" }}>
          設備機材利用管理システム
        </h1>
        <p className="page-subtitle" style={{ textAlign: "center" }}>
          登録されたメールアドレスとパスワードでログインしてください。
        </p>

        <div className="form-field">
          <label>メールアドレス</label>
          <input
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-field">
          <label>パスワード</label>
          <PasswordInput
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {error && <p className="error-text">{error}</p>}

        <button type="submit" className="btn btn-primary btn-block" disabled={submitting}>
          {submitting ? "ログイン中..." : "ログイン"}
        </button>
      </form>
    </div>
  );
}
